export default __webpack_public_path__ + "static/media/logoOli.017d248b.svg";